import PropTypes from 'prop-types';
import playerImg from '../../../images/player.png';
import { FILE_BASE_URL } from '../../../apiConfig';

function CommitteeCard({ data }) {
    const profileImg = data.Profile_image ? `${FILE_BASE_URL}/${data.Profile_image}` : playerImg;

    const styles = {
        card: {
            width: '100%',
            maxWidth: '300px',
            background: 'linear-gradient(145deg, var(--blue) 0%, #030640 100%)',
            borderRadius: '16px',
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            padding: '24px 16px',
            borderBottom: '5px solid var(--yellow)',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
        },
        imageWrapper: {
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            overflow: 'hidden',
            border: '4px solid #ffffff',
            marginBottom: '16px',
            background: '#ffffff',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
        },
        name: {
            fontFamily: 'var(--fontDisplay), "Oswald", sans-serif',
            fontSize: '1.25rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            color: '#ffffff',
            margin: '0 0 6px 0',
            textAlign: 'center',
            letterSpacing: '0.5px'
        },
        position: {
            fontFamily: 'var(--fontBody), "Inter", sans-serif',
            fontSize: '12px',
            fontWeight: 700,
            color: 'var(--yellow)',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: '16px',
            textAlign: 'center'
        },
        contactWrapper: {
            width: '100%',
            background: 'rgba(255,255,255,0.08)',
            borderRadius: '8px',
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            alignItems: 'center',
            marginTop: 'auto'
        },
        contactText: {
            fontFamily: 'var(--fontBody), "Inter", sans-serif',
            fontSize: '12px',
            color: '#f0f0f0',
            margin: 0,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '100%',
            textAlign: 'center'
        }
    };

    return (
        <div style={styles.card} 
             onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.2)'; }}
             onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)'; }}>
            
            <div style={styles.imageWrapper}>
                <img src={profileImg} 
                     alt={data.name || 'Committee Member'} 
                     style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                     onError={(e) => { e.target.onerror = null; e.target.src = playerImg; }} />
            </div>

            <h3 style={styles.name}>{data.name}</h3>
            <span style={styles.position}>{data.position}</span>

            {(data.email || data.phone) && (
                <div style={styles.contactWrapper}>
                    {data.email && <span style={{...styles.contactText, color: 'var(--yellow)', fontWeight: 600}}>{data.email}</span>}
                    {data.phone && <span style={styles.contactText}>{data.phone}</span>}
                </div>
            )}
        </div>
    );
}

export default CommitteeCard;